/**
 * @module
 * @author Bayu Dwiyan Satria
 * @since 1.0.0
 */

/**
 * Shorten a profile URL to the part worth reading.
 *
 * @remarks
 * `github.com/example` identifies the destination as well as the full URL does and survives a
 * narrow column, which the full URL does not. Two components render the same `identityConfig.profiles`
 * array — the footer and the author route — so the shortening lives here rather than in whichever
 * one was written first: two copies of a display rule are two rules the moment one is edited.
 *
 * The scheme is dropped rather than hidden, so the visible text is not a URL and cannot be mistaken
 * for one that was typed wrong. The `href` is always the untouched original.
 *
 * @param url - Absolute URL, normally an entry from `identityConfig.profiles`.
 * @returns The URL without its scheme, `www.` prefix or trailing slash.
 *
 * @example
 * ```ts
 * hostLabel('https://www.linkedin.com/in/example/') // 'linkedin.com/in/example'
 * ```
 */
export function hostLabel(url: string): string {
  return url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '')
}
